import { useContext, useEffect } from 'react';
import { useNextMicro, useSingleton, useUpdate } from '@bydesign-ui/hooks';
import { GroupItem } from '../../../models/group';
import { GroupContext } from '../context/group';
export function useGroupItem(props) {
  var update = useNextMicro(useUpdate());
  var groupInfo = useContext(GroupContext);

  if (groupInfo == null) {
    throw new Error('use RcGroupItem not in RcGroup');
  }

  var itemInfo = useSingleton(function () {
    return new GroupItem(groupInfo, props);
  });
  var conf = itemInfo.getGroupItemInfo(props);
  useEffect(function () {
    itemInfo.addListener('group-change', update);
    return function () {
      itemInfo.removeListener('group-change', update);
      itemInfo.dispose();
    };
  }, [itemInfo]);
  return conf;
}